module.exports = __webpack_public_path__ + "img/brands-pan-hero.jpg?e3096df32eee3f0d871b6bc959de3234";